<template>
	<div class="popular" id="popular">
		<section class="man-top">
			<a class="bw-logo" href="http://www.cosmopolitan.com.tw/" target="_blank"><img src="../assets/images/bw-logo.png" alt=""></a>
			<img v-if="screenWidth>1200" src="../assets/images/d-popular-title.png" alt="">
			<img v-else src="../assets/images/m-popular-title.png" alt="">
			<div class="vote-pd-class-container">
				<div class="vote-pd-class-text" v-for="(ProcuctClass,index) in allProcuctClass" :key="ProcuctClass.engName" v-scroll-to="'#category-conatiner'+index+''">
					<p class="vote-pd-class-eng">{{ ProcuctClass.engName }}</p>
					<h3 class="vote-pd-class-chi">{{ ProcuctClass.chiName }}</h3>
				</div>
			</div>
		</section>

		<section class="man-pd-container">
			<div :id="'category-conatiner'+index" class="category-conatiner" v-for="(category,index) in manProduct"  >
				<div class="category-title">
					 <p class="category-name-eng">{{ allProcuctClass[index].engName }} </p>
					 <h1 class="category-name">{{ allProcuctClass[index].chiName }} </h1>
				</div>
				<div class="pd-item pd-top1" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[1].image) + ')'}" :key="category[1].no" v-on:click="saveModalShowPd(category[1])" data-toggle="modal" data-target="#Modal">
					<div class="pd-cover">
						<h4 class="pd-brand"> {{ category[1].brand }} </h4>
						<p> {{ category[1].product }} </p>
						<div class="pd-detail">
							產品說明
						</div>
					</div>
				</div>
				<div class="pd-item pd-top2" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[2].image) + ')'}" :key="category[2].no" v-on:click="saveModalShowPd(category[2])" data-toggle="modal" data-target="#Modal">
					<div class="pd-cover">
						<h4 class="pd-brand"> {{ category[2].brand }} </h4>
						<p> {{ category[2].product }} </p>
						<div class="pd-detail">
							產品說明
						</div>
					</div>
				</div>
				<div class="pd-item pd-top3" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[3].image) + ')'}" :key="category[3].no" v-on:click="saveModalShowPd(category[3])" data-toggle="modal" data-target="#Modal">
					<div class="pd-cover">
						<h4 class="pd-brand"> {{ category[3].brand }} </h4>
						<p> {{ category[3].product }} </p>
						<div class="pd-detail">
							產品說明
						</div>
					</div>
				</div>
				<div class="pd-item pd-star" v-bind:style="{backgroundImage: 'url(' + setImageUrl(category[4].image) + ')'}" :key="category[4].no" v-on:click="saveModalShowPd(category[4])" data-toggle="modal" data-target="#Modal">
					<div class="pd-cover">
						<h4 class="pd-brand"> {{ category[4].brand }} </h4>
						<p> {{ category[4].product }} </p>
						<div class="pd-detail">
							產品說明
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="event-description">
			<ul class="event-list">
				<li>評選說明
					<p>於活動期間 2017/09/11 ~ 09/24，從專業美容老師所評選出 16 個品項的 TOP 10，選擇你喜愛的產品進行投票，與我們共同評選出人氣口碑獎，有機會獲得柯夢波丹為你準備的精美美妝小禮!</p>
				</li>
				<li>活動贈品
					<img src="../assets/images/d-gift.png" alt="" class="gift" v-if="screenWidth>1200">
					<img src="../assets/images/m-gift.png" alt="" class="gift-m" v-else>
				</li>
				<li>得獎權利與義務
					<p>依照中華民國國稅局規定，參加任何活動得獎，獎項價值超過新台幣10,000以上須做得獎申報扣繳，得獎者應先傳真(02-2500-1986)或郵寄提供申報相關文件(身分證正反影本)予主辦單位，始得領取活動獎品。活動獎項價值超過新台幣20,000元者，得獎者應自行負擔10%之機會中獎所得稅。</p>
				</li>
				<li>注意事項
					<ul class="care-list">
						<li>每人限得獎一次，若發現重複得獎，主辦單位得取消其中任一獎項，並由備取者遞補。</li>
						<li>本活動限中華民國台灣地區(台澎金馬地區)之使用者參加，本活動之獎品不得轉換、轉讓或折換現金。</li>
						<li>活動期間如有任何問題，可來信至e-mail:cosmo_service@hearst.com.tw 聯絡。</li>
						<li>參加者於參加活動同時，即同意接受本活動注意事項之規範，如果違反本活動注意事項之行為，主辦單位得取消其參加或得獎資格，並對於任何破壞活動之行為保留相關權利。</li>
						<li>請確認註冊Facebook皆為正確資料，主辦方所有資料皆會保密，只作為參賽者聯繫、聯絡通知或獎品寄送之依據。填寫錯誤資訊以致 聯絡誤差，將視同放棄參賽資格。</li>
						<li>參加者所參與獲提供的活動內容，不符合活動辦法之規範，主辦單位得取消其參加或得獎資格，且不另行通知。</li>
						<li>如果不實或不正確之情事，將被取消參加資格:如為得獎者，則取消得獎資格。如因此致主辦單位無法通知其得獎訊息時，主辦單位不負任何責任。且如有致損害於主辦單位或其他任何第三人，參加者應負一切民刑事責任。</li>
						<li>如有任何因電腦、網路、電話、技術或不可歸責於主辦單位之事由，而使寄予得獎人之獎品有延遲、遺失、錯誤、無法辨識或毀損之 情況，主辦單位不負任何法律責任，參加者亦不得因此異議。</li>
						<li>活動因故無法進行時，主辦單位有權決定取消、終止、修改或暫停活動。</li>
						<li>活動獎項若因不可抗力因素需要調整，主辦單位保留改以他項等值獎品代替之權利。</li>
					</ul>
				</li>
				<li>得獎名單
					<p>公佈於 2017 10月 柯夢波丹粉絲團。</p>
				</li>
				<li>領獎方式
					<ul class="care-list">
						<li>得獎者應於柯夢波丹通知之一週內回覆確認同意領取獎品，並提供柯夢波丹所要求之完整領獎文件，逾期視為棄權。</li>
						<li>台灣本島與澎湖、金馬地區:獎品將一律以掛號方式配送以避免遺失，得獎者須於名單公佈通知後，須回覆相關配送資料，逾期回覆則視同放棄領獎資格。</li>
					</ul>
				</li>
			</ul>
		</section>
		<Modal :modalShownSon="modalShown" :votePageShowPd="modalPd" :imgUrl="cosmoUrl" :sendPage="'man'"  ></Modal>
	</div>
</template>

<script>
import Modal from '../components/Modal'
var VueScrollTo = require('vue-scrollto')
export default{
	name: 'popular',
	data(){
		return {
			modalShown: false,
			modalPd : {},
			manCategory:{
				1:{
					title: "初戀顏"
				},
				2:{
					title: "電眼殺手"
				},
				3:{
					title: "最撩人唇"
				},
				4:{
					title: "心動雙頰"
				},
				5:{
					title: "誘人香氣"
				},
				6:{
					title: "迷人髮香"
				}
			},
			manProduct:{
				1: {
					1:{
						"no": 1,
						"brand": "Giorgio Armani",
						"product": "完美絲絨水慕斯粉底SPF25",
						"price": "NT.2250",
						"capacity" : "30ml",
						"image" : "1-4.jpg",
						"detail": "首創 「超時持妝科技」能長時間有效控油、抵抗汗水，維持 16 小時不脫妝。獨家「無瑕柔焦科技」能完美遮蓋瑕疵、柔焦毛孔、修飾膚色不均，訂製完美無瑕妝感。革命性「超微服貼粉體」極細緻粉體，能順應臉部線條、如第二層肌膚般服貼完美宛若天生。"
					},
					2:{
						"no": 2,
						"brand": "SHISEIDO資生堂國際櫃",
						"product": "時尚色繪尚質長效精華粉蜜SPF20",
						"price": "NT.1400",
						"capacity" : "30ml",
						"image" : "1-8.jpg",
						"detail": "內含透明修飾聚合物，配方輕盈具高黏性能服貼肌膚，並以其高度擴散光特性，藉由補光修飾毛孔、細紋等粗糙紋理。並添加多種天然植物萃取，包括小連翹萃取精華、野百里香萃取精華，結合保養成份水分感應聚合物+甘油，其高度生物相容成分能偵測環境周圍的濕度與肌膚水分，在乾燥環境中達到加強保濕作用。"
					},
					3:{
						"no": 3,
						"brand": "INTEGRATE",
						"product": "勻色遮瑕蜜SPF13 PA++",
						"price": "NT.240",
						"capacity" : "4.5g",
						"image" : "1-6.jpg",
						"detail": "擁有雙重修飾效果，光澤效果以微細的偏光珍光粉末形成光影遮瑕效果，能補正膚色不均。毛孔遮瑕效果添加純淨遮瑕粉末能修飾肌膚凹凸，讓膚質明亮柔滑，能修飾黑眼圈、痘疤與粗大毛孔等細微瑕疵。"
					},
					4:{
						"no": 4,
						"brand": "ESTEE LAUDER 雅詩蘭黛",
						"product": "粉持久完美持妝粉底SPF10/PA++",
						"price": "NT.1600",
						"capacity" : "30ml",
						"image" : "1-3.jpg",
						"detail": "運用獨特15小時完美膚控持妝科技，隨時抗油抗汗，並採用超微柔焦隱型粉體，上妝瞬間完美貼緊肌膚，隱藏所有瑕疵。添加不使肌膚乾燥、不會堵塞毛孔的升級控油成分科技，形成一層清爽、可呼吸且柔韌度極佳的薄膜，妝感服貼舒適，妝效更加完美均勻。"
					}
				},
				2: {
					1:{
						"no": 5,
						"brand": "PONY EFFECT",
						"product": "持久無瑕氣墊粉餅SPF50+ PA+++",
						"price": "NT.1650",
						"capacity" : "15gx2",
						"image" : "2-6.jpg",
						"detail": "全新粉體親膚科技，使用三種不同大小的粉體分子，完美覆蓋瑕疵、平滑毛孔，並防止肌膚暗沈，呈現無瑕肌膚；運用獨家控油柔光微粒，完美油水比例平衡調控，上妝後與肌膚結合，將妝感轉化為適合個人的無瑕膚質狀態。內含多種植物萃取的鎮定活性複合因子，幫助鎮定肌膚，還原好氣色。"
					},
					2:{
						"no": 6,
						"brand": "后",
						"product": "天氣丹華炫雙層蕾絲氣墊粉底",
						"price": "NT.3780",
						"capacity" : "15g",
						"image" : "2-10.jpg",
						"detail": "明亮膚色、改善皺紋的雙層式氣墊式粉底，質地輕盈且遮瑕力佳，添加高保濕抗老精華，打造出水嫩光采，讓肌膚暢快呼吸。"
					},
					3:{
						"no": 7,
						"brand": "Za",
						"product": "裸光亮白氣墊粉餅 SPF30 PA++",
						"price": "NT.590",
						"capacity" : "12g",
						"image" : "2-9.jpg",
						"detail": "為喜愛自然光澤妝感卻又在意局部遮瑕的亞洲女性研發，快速創造裸光亮白膚質。集結提亮白皙、裸透無瑕、水潤保濕等三大美肌效果。提亮膚色不泛白，長時間持粧且不易暗沉脫妝，獨特的細緻粉體搭配觸感柔軟的氣墊粉撲，完美修飾毛孔、細紋與斑點，高效保濕成分玻尿酸為肌膚維持水潤柔嫩。"
					},
					4:{
						"no": 8,
						"brand": "Dior迪奧",
						"product": "超完美持久氣墊粉餅",
						"price": "NT.1850",
						"capacity" : "15g",
						"image" : "2-2.jpg",
						"detail": "即使在炎熱、潮濕或極端氣候，獨家鎖色持妝科技與專利粉體都能保持妝容不脫妝、不掉色，16小時完美無瑕。添加「瞬效柔焦粒子」，將極致清新的粉底液轉化成細緻服貼的粉體，立即柔焦綻放柔霧光。毛孔隱形科技保養精華在上妝同時，能有效改善毛孔粗大、油光等問題。"
					}
				},
				3: {
					1:{
						"no": 9,
						"brand": "BOBBI BROWN",
						"product": "毛孔隱形精華",
						"price": "NT.1500",
						"capacity" : "25ml",
						"image" : "3-1.jpg",
						"detail": "運用極效柔膚粉底科技，添加了高效柔焦粉末，能平滑均勻地在肌膚上推開，且不會產生乾燥感、掉妝、脫屑或碎屑，並能發揮瞬間柔焦效果，立即創造出光滑、無瑕的零毛孔美肌。"
					},
					2:{
						"no": 10,
						"brand": "CLINIQUE倩碧",
						"product": "勻淨白修護BB霜 SPF29/PA+++",
						"price": "NT.1350",
						"capacity" : "30ml",
						"image" : "3-3.jpg",
						"detail": "質地輕薄、柔軟、絲滑的BB霜能立即明亮肌膚及遮蓋修飾黑斑與不均勻的膚色，配方中維生素C等美白成分能長期發揮作用，改善紫外線傷害留下的明顯痕跡，持續使用則能淡化黑斑與老化斑點。無油配方不易致痘，防汗、抗潮濕、防水。"
					},
					3:{
						"no": 11,
						"brand": "Freshel 膚蕊",
						"product": "美肌淨透BB霜(極潤)",
						"price": "NT.450",
						"capacity" : "50g ",
						"image" : "3-6.jpg",
						"detail": "富含滋潤的濃滑膚觸將滋潤牢牢鎖住的防護罩效果，讓滋潤成份長時間維持不易流失，具高遮瑕的淡妝效果，能確實遮飾細紋與斑點，打造逆齡般的亮澤彈潤美顏以及，同時隔離紫外線，保護肌膚不受艷陽的傷害。"
					},
					4:{
						"no": 12,
						"brand": "SHISEIDO資生堂東京櫃",
						"product": "心機星魅蜜桃光CC霜 SPF 25 PA+++",
						"price": "NT.850",
						"capacity" : "30g ",
						"image" : "3-9.jpg",
						"detail": "囊中釋放出內含的明亮蜜桃色澤，幫助有效保濕成分充分融合肌膚內，形成保濕網絡，使肌膚結構間緊緊鎖住水份。為了強化肌膚在日間的防禦力SPF25 PA+++的防曬係數採用無色防禦薄膜，可為肌膚防禦紫外線、乾燥及空氣中的細微髒污。"
					}
				},
				4: {
					1:{
						"no": 13,
						"brand": "MAYBELLINE媚比琳",
						"product": "超激細抗暈眼線液抗手震版",
						"price": "NT.350",
						"capacity" : "0.5g ",
						"image" : "4-5.jpg",
						"detail": "獨特超發色配方能輕鬆創造出眼線的超亮漆黑感，輕易散發光線均勻折射的濃烈光澤感。有別於一般傳統眼線液的墨水僅能呈現灰霧線條，立即塑造立體輪廓，加深對比，使雙眼深邃有神，勾勒出俐落深邃的誘人眼線。"
					},
					2:{
						"no": 14,
						"brand": "TOM FORD",
						"product": "高級訂製四格眼盤",
						"price": "NT.3100",
						"capacity" : "6g ",
						"image" : "4-8.jpg",
						"detail": "大量運用了不同質地、光澤與獨特的顏色組合，創造出一款款動人且獨一無二的眼盤，從閃耀的光芒、細緻動人的珠光，再到高貴優雅的霧面質地，顏色的搭配上延續他對於色彩的敏銳度，即使是四款顏色交互層疊，以能輕鬆駕馭出專屬於你的獨特時尚魅力。"
					},
					3:{
						"no": 15,
						"brand": "戀愛魔鏡",
						"product": "捲捲女爵超捲翹睫毛膏",
						"price": "NT.340",
						"capacity" : "6g ",
						"image" : "4-10.jpg",
						"detail": "捲翹拉提刷頭只要順著刷頭角度，將睫毛自根部1mm處輕刷即能向上拉提梳展，即能使睫毛捲翹定型。富含液態超延展膏體能均勻地附著睫毛不結塊，讓睫毛長度與份量感加倍，纖長又濃密。添加濃翹持久定型配方，持妝不暈染，高效防水抗油光。"
					},
					4:{
						"no": 16,
						"brand": "KATE凱婷",
						"product": "造型雙效眼線筆",
						"price": "NT.380",
						"capacity" : "眼線液0.4ml 眼線膠0.1g",
						"image" : "4-2.jpg",
						"detail": "極細眼線液×眼線膠的雙頭眼線筆眼線筆，能輕易變化出不同的眼線畫法，打造深邃迷人眼神。"
					}
				},
				5: {
					1:{
						"no": 17,
						"brand": "Dior迪奧",
						"product": "癮誘超模染唇露",
						"price": "NT.1050",
						"capacity" : "6ml",
						"image" : "5-3.jpg",
						"detail": "宛如以微刺青的技術將色彩鎖於雙唇，輕薄緊貼唇肌，讓美唇宛如天生，輕輕一抹，摩登色彩立即緊貼雙唇肌膚，像是為妳的一天刺上獨有的美唇印記。不需要任何美妝技巧的唇露，每個女生皆能輕易上手。"
					},
					2:{
						"no": 18,
						"brand": "ESTEE LAUDER 雅詩蘭黛",
						"product": "玩色戀愛唇膏",
						"price": "NT.900",
						"capacity" : "3.5g",
						"image" : "5-4.jpg",
						"detail": "擁有最豐富的25種多元色彩、4種不同唇彩質地，可自由運用搭配使用，只要精準掌握「顏色」與「質地」兩大唇彩混搭的重點要訣，人人皆可混合配搭獨一無二、不與他人重複的個人唇妝。"
					},
					3:{
						"no": 19,
						"brand": "SHISEIDO資生堂東京櫃",
						"product": "心機星魅唇膏",
						"price": "NT.980",
						"capacity" : "4.1g",
						"image" : "5-10.jpg",
						"detail": "嚴選高濃密美容純油精製而成，當唇膏接觸到雙唇後藉由唇溫讓美容純油融化並分離為兩層，在外部形成一層保濕薄膜，改善唇部乾燥現象；並將濃密飽和的色澤緊密附著於唇部，修飾唇紋及暗沉唇色，無論是色澤、顯色度或潤澤感都持久不褪色。"
					},
					4:{
						"no": 20,
						"brand": "Giorgio Armani",
						"product": "奢華絲絨訂製唇萃",
						"price": "NT.1200",
						"capacity" : "6.5ml",
						"image" : "5-5.jpg",
						"detail": "獨家「4D 絲絨霧光球體」能讓自然光線穿透球體間隙,呈現出具有律動感的自然光反射效果,使絲絨般霧面唇色煥發細緻長達 8 小時的優雅光澤感。「絲絨柔滑凝膠」宛如液態護唇膏的成分, 加倍滑順且服貼,深入唇部肌膚與唇紋深處,發揮毫不黏膩的輕盈潤唇效果。"
					}
				},
				6: {
					1:{
						"no": 21,
						"brand": "Clé de peau BEAUTÉ 肌膚之鑰",
						"product": "果漾妍彩霜",
						"price": "NT.1500",
						"capacity" : "6g",
						"image" : "6-1.jpg",
						"detail": "添加完美色調複合物與3種油脂滑順配方，使頰彩色調更顯鮮豔兼具透明水潤光澤感、高延展性。添加光采明亮複合物EX與摩洛哥堅果油使雙頰更顯保濕潤澤感。"
					},
					2:{
						"no": 22,
						"brand": "RMK",
						"product": "經典修容N",
						"price": "NT.1100",
						"capacity" : "2.6g",
						"image" : "6-9.jpg",
						"detail": "宛如肌膚的一部分般的融合，以純淨發色彩繪出輕柔雙頰的經典修容N，給予雙頰自然的紅潤感，輕盈綿柔的發色如同肌膚由內而外自然呈現般的紅潤"
					},
					3:{
						"no": 23,
						"brand": "CHANEL香奈兒",
						"product": "BB腮紅霜",
						"price": "NT.1600",
						"capacity" : "8g",
						"image" : "6-2.jpg",
						"detail": "方便隨身攜帶的BB腮紅霜其質地如絲絨般細膩滑順，宛如第二層肌膚般自然輕透，輕輕以指腹推開暈染就能讓溫暖色彩完美融入底妝中，柔和的色澤瞬間融入肌底，雙頰散發出紅潤好氣色。細緻的珍珠分子能賦予肌膚透亮，使臉龐閃耀細緻的光澤並且帶來柔焦效果。"
					},
					4:{
						"no": 24,
						"brand": "M．A．C",
						"product": "超激光腮紅",
						"price": "NT.950",
						"capacity" : "6.5g",
						"image" : "6-7.jpg",
						"detail": "超激光腮紅完整囊括橘色、土色、珊瑚色、玫瑰色、桃色等色系，融合超激光炫彩餅最具代表性的細膩偏光，打造完美氣色。結合霜狀的滑順、液狀的高融合性以及粉狀的定妝效果，呈現如同第二層肌膚的服貼妝感。雕塑臉部輪廓和提亮妝容。"
					}
				},
				7: {
					1:{
						"no": 1,
						"brand": "SHISEIDO資生堂東京櫃",
						"product": "碧麗妃溫℃感卸妝凝膠",
						"price": "NT.1350",
						"capacity" : "150g",
						"image" : "7-9.jpg",
						"detail": "全新添加的溫感亮膚成分，在接觸到空氣中的水分時會產生溫感，以雙手輕輕搓揉般按摩，讓溫感效果由內而外溫暖肌膚，並利用凝膠質地其附著性佳的特性，將難以卸除的彩粧及殘留在肌紋、毛孔深處的髒污溶出，在卸粧的同時也軟化角質，以清水或溫水洗淨後，引出素顏本身的透明感，呈現柔滑水潤的光澤。"
					},
					2:{
						"no": 2,
						"brand": "COSME DECORTE 黛珂",
						"product": "礦物拋光洗顏霜",
						"price": "NT.990",
						"capacity" : "171g",
						"image" : "7-2.jpg",
						"detail": "添加自然礦物泥與5種植物淬取精華的溫和配方，綿密柔滑又有彈力的綿密泡沫，溫和洗顏同時徹底清潔髒污以及老廢角質，洗顏後肌膚如拋光般，光滑Q彈，細緻水潤，散發自然光澤。"
					},
					3:{
						"no": 3,
						"brand": "Kiehl's契爾氏",
						"product": "金盞花植物精華潔面泡泡凝露",
						"price": "NT.950",
						"capacity" : "230ml",
						"image" : "7-7.jpg",
						"detail": "金盞花又被稱為「天然的抗生素」，加入至潔面產品中利用金盞花的植物藥性，帶走肌膚表層毒素髒污，能真正深層清潔肌膚。氨基酸活性成分，溫和潔面泡沫不破壞肌膚屏障，給予肌膚最溫和的保濕的能力讓肌膚不因為洗臉而失去水分。"
					},
					4:{
						"no": 4,
						"brand": "Curél珂潤",
						"product": "潤浸保濕深層卸粧凝露",
						"price": "NT.400",
						"capacity" : "130g",
						"image" : "7-3.jpg",
						"detail": "溫和配方專為敏感肌膚設計，無香料、無色素通過敏感測試、通過貼布測試。連難卸除的口紅、毛孔深處的粉底以及防曬乳液等都可以徹底卸除，不會對角質層保濕機能造成負擔。能預防乾燥問題、提升肌膚屏護，舒緩因肌膚乾燥引起的不適。"
					}
				},
				8: {
					1:{
						"no": 5,
						"brand": "DARPHIN",
						"product": "活水保溼深層滲透精華液",
						"price": "NT.2650",
						"capacity" : "30ml",
						"image" : "8-3.jpg",
						"detail": "結合源自諾貝爾得獎理論的澳洲「白茅」精華能夠平衡肌膚最佳的水含量,同時其多元水果細胞精華可補足肌膚所需的養分,搭配紅石榴、尿素及極效鎖水因子,以最強大的高滲透保濕因子,深入重建乾渴受損肌膚,讓細胞內的水分通道恢復健康,改善肌膚缺水問題。"
					},
					2:{
						"no": 6,
						"brand": "SOFINA",
						"product": "芯美顏 保濕滲透露升級版 清爽型",
						"price": "NT.850",
						"capacity" : "140ml",
						"image" : "8-9.jpg",
						"detail": "水潤高滲透配方能滲透至角質層，貯水力保水配方讓乾燥缺水的角質層，緊緊鎖住水分，使角質層會變得柔軟提升肌膚寶水度，調整肌理使後續保養品更加容易吸收。"
					},
					3:{
						"no": 7,
						"brand": "ESTEE LAUDER 雅詩蘭黛",
						"product": "白金級絕世煉金花秘水精華",
						"price": "NT.4000",
						"capacity" : "75ml",
						"image" : "8-4.jpg",
						"detail": "以融合性極佳的離子水作為基底，將晨露美肌力、喜馬拉雅冰原白龍膽花、巴西旱地永生花成功轉化為開啟年輕肌密的奢華配方，打造為超濃縮的全新水精華質地，能快速將保養成分滲透肌底。使肌膚柔嫩、保濕、明亮、緊緻、拉提，一舉激活肌膚五大年輕力。"
					},
					4:{
						"no": 8,
						"brand": "COSME DECORTE 黛珂",
						"product": "保濕美容液",
						"price": "NT.2880",
						"capacity" : "40ml",
						"image" : "8-2.jpg",
						"detail": "包在多重層微脂囊體內的成份，能緩慢長時間點滴釋出，將保濕成份傳送到每一吋肌膚。親膚性強，能滑順地滲入角質層，立即舒解乾荒，妝前使用能使底妝更加服貼持久。能長時間釋放保濕成分、持續滋潤，將肌膚調理到最佳狀態，幫助後續保養品滲透。"
					}
				},
				9: {
					1:{
						"no": 9,
						"brand": "su:m37甦秘",
						"product": "微米珍珠奇蹟淨白光澤霜",
						"price": "NT.3680",
						"capacity" : "45g",
						"image" : "9-8.jpg",
						"detail": "蘊含高濃縮微米發酵珍珠蛋白安瓶膠囊，高效能集中亮白肌膚，天然發酵複合物，深入肌底有效緊緻肌膚，肌膚由內而外緊緻彈嫩並帶有珍珠般亮白光澤感，適合各種膚質。尤適合暗沉、蠟黃之肌膚。"
					},
					2:{
						"no": 10,
						"brand": "THE FACE SHOP 菲詩小舖",
						"product": "蘂花譚雪蓮亮白真珠霜",
						"price": "NT.2600",
						"capacity" : "50ml",
						"image" : "9-9.jpg",
						"detail": "內含晶瑩珍珠和珍貴天山雪蓮，有著亮白+集中修護效果，透過低溫冷卻膠囊技術，將添加天山雪蓮、珍珠粉、膠原蛋白濃縮於雪白真珠中，輕壓真珠即化為綿密乳霜，讓肌膚在塗抹的瞬間，將最新鮮的高效淨白融入肌底，使肌膚瞬間綻亮。"
					},
					3:{
						"no": 11,
						"brand": "CLINIQUE倩碧",
						"product": "勻淨科研淡斑修護雙精萃",
						"price": "NT.3500",
						"capacity" : "50ml",
						"image" : "9-1.jpg",
						"detail": "採用客製化的旋轉式壓頭設計，小滴適合油性及混合性肌膚，亦或是因應亞洲夏季悶熱的氣候，而大滴適合普通及乾性肌膚，或是乾冷的氣候。採用全植物油萃取，質地上更為輕盈，油性肌膚使用上也無清爽無負擔。因採用水溶性精萃與油溶性精萃分裝的瓶身設計，不使用介面活性劑，敏感肌膚也可以安心使用。"
					},
					4:{
						"no": 12,
						"brand": "Kiehl's契爾氏",
						"product": "激光極淨白淡斑精華",
						"price": "NT.2400",
						"capacity" : "30ml",
						"image" : "9-4.jpg",
						"detail": "使用皮膚科用於治療黑色素沉著症的醫美級別美白處方箋激光活能C，並添加木糖複合物、山毛櫸精萃與腺苷，不僅能達到淨白、淡斑與保濕，更能有效協同膠原蛋白增生，提升肌膚彈性。"
					}
				},
				10: {
					1:{
						"no": 13,
						"brand": "CLARINS克蘭詩",
						"product": "黃金雙激萃超級精華",
						"price": "NT.2900",
						"capacity" : "30ml",
						"image" : "10-1.jpg",
						"detail": "克蘭詩年度最強新品，黃金雙激萃超級精華。"
					},
					2:{
						"no": 14,
						"brand": "L'OCCITANE歐舒丹",
						"product": "蠟菊賦活極萃霜",
						"price": "NT.4480",
						"capacity" : "50ml",
						"image" : "10-5.jpg",
						"detail": "雛菊精萃可均勻提亮膚色，以及多種植物精萃，重塑臉部輪廓線條改善細紋，斑點、鬆弛、缺乏彈性及乾燥等問題，給予肌膚充沛的抗老能量，重拾年輕緊緻的飽滿膚質，膚色更加透亮、柔嫩緊實，持續煥發動人青春光采。"
					},
					3:{
						"no": 15,
						"brand": "DARPHIN",
						"product": "深海緊緻賦活黑鑽能量安瓶",
						"price": "NT.15500",
						"capacity" : "5mlx6",
						"image" : "10-3.jpg",
						"detail": "極具奢華感的白銀安瓶外包裝,內有一組6支附滴管安瓶,每瓶蘊含5毫升的高濃度精華的深海緊緻賦活黑鑽能量安瓶,擁有絲滑細緻的完美質地,能快速滲透肌膚,在短短的28天內密集為肌膚高效護理,為自我臉龐肌膚打造抗老再生的。"
					},
					4:{
						"no": 16,
						"brand": "Dior迪奧",
						"product": "精萃再生花蜜乳霜",
						"price": "NT.10600",
						"capacity" : "50ml",
						"image" : "10-2.jpg",
						"detail": "蘊含在岡維拉玫瑰花辦細胞膜內的8種獨特珍稀青春分子，透過獨家極凍音波萃取工藝，精萃出濃度為前一代產品40倍高的精萃再生花蜜精華，可有效修復肌膚微發炎反應，讓肌膚宛如觸感柔細的玫瑰花辦般，完美細緻。"
					}
				},
				11: {
					1:{
						"no": 17,
						"brand": "SHISEIDO資生堂東京櫃",
						"product": "安耐曬金鑽高效防曬乳SPF50+‧PA++++",
						"price": "NT.750",
						"capacity" : "40ml",
						"image" : "11-5.jpg",
						"detail": "360°全罩防禦膜技術塗抹後可使防禦膜厚薄均勻且服貼於皮溝及皮丘，充分發揮紫外線防禦力，具有耐水、耐汗的特性，在肌膚表面形成高效的網狀防禦膜，不因接觸到汗水等水分時的影響而降低防曬效果。"
					},
					2:{
						"no": 18,
						"brand": "CHANEL香奈兒",
						"product": "珍珠光感防曬水凝露",
						"price": "NT.2000",
						"capacity" : "30ml ",
						"image" : "11-1.jpg",
						"detail": "結合隔離功能與獨特配方，肌膚猶如穿上量身打造的抗污染隔離層，獨家肌膚防護複合成份有助維持幹細胞的整合力及功能之運作，進而增強肌膚的防禦功能。有別於以往常見的乳液質地，以膠狀凝露帶來極致清爽與輕薄透氣的極致體驗，另外更含有高防曬係數 SPF 50 /PA+++，全方位防護肌膚。"
					},
					3:{
						"no": 19,
						"brand": "KOSE COSMEPORT 蔻絲魅寶",
						"product": "SUNCUT UV曬可皙高效防曬噴霧SPF50+ PA++++",
						"price": "NT.298/358",
						"capacity" : "50g/90g",
						"image" : "11-4.jpg",
						"detail": "超清爽、不泛白 添加10種植物淬取液與清爽粉體，使用時肌膚清爽，不黏膩，透明不泛白。幾近無感的高效防曬徹底保護秀髮與肌膚免於紫外線傷害。不添加礦物油、防腐劑，杜絕紫外線侵襲同時也不造成肌膚負擔與刺激不適。可用於頭髮、頭皮、背部…甚至腳趾等容易忽略部位，提供的全面性的防護。"
					},
					4:{
						"no": 20,
						"brand": "Kiehl's契爾氏",
						"product": "集高效清爽 UV 防護乳 SPF50 PA++++",
						"price": "NT.1400",
						"capacity" : "30ml",
						"image" : "11-3.jpg",
						"detail": "擁有革命性 UV 防護科技能夠真正抵擋可怕的長波 UVA,有效隔絕各種傷害肌膚的紫外線,真正達到避免肌膚曬黑曬老與曬傷,一網打盡抵達地表三種肌膚損害性紫外線。輕透、水潤的質地清爽無負擔,100%不添加油脂,讓肌膚擦上防曬後,即使到了下午也無須擔心出油問題。"
					}
				},
				12: {
					1:{
						"no": 21,
						"brand": "Sisley",
						"product": "黑玫瑰頂級乳霜抗老面膜",
						"price": "NT.4500",
						"capacity" : "60ml",
						"image" : "12-6.jpg",
						"detail": "富含礦物質微量元素、維他命及植物精萃成分的乳霜質地面膜，獨特配方可改善歲月痕跡及疲倦面容，立即感受肌膚恢復活力光采。只要15分鐘肌膚恢復平滑飽滿 、 肌膚重現活力。"
					},
					2:{
						"no": 22,
						"brand": "品木宣言",
						"product": "奇蹟抗痘面膜",
						"price": "NT.1000",
						"capacity" : "100ml",
						"image" : "12-9.jpg",
						"detail": "超強吸收力的氧化鋅和硫磺，搭配舒緩的樟樹精華，能迅速吸油，並清除老廢角質和收斂毛孔，讓肌膚遠離油光，同時修護粗糙膚質，預防產生痘痘。"
					},
					3:{
						"no": 23,
						"brand": "后",
						"product": "天氣丹津率享紅山蔘清氣面膜",
						"price": "NT.2680",
						"capacity" : "100ml",
						"image" : "12-10.jpg",
						"detail": "是款無油配方、質地清爽的精華面膜，同時也可當成晚安面膜來使用，厚膚一層使肌膚充滿水潤感，內附紫檀木按摩片可搭配按摩手法加速保養品吸收力。"
					},
					4:{
						"no": 24,
						"brand": "Kiehl's契爾氏",
						"product": "亞馬遜白泥淨緻毛孔面膜",
						"price": "NT.1200",
						"capacity" : "125ml",
						"image" : "12-4.jpg",
						"detail": "有解毒聖品之稱的亞馬遜白泥，能深入毛孔清除白頭和黑頭粉刺、髒污與多於油脂，使毛孔乾淨暢通，讓清潔後的毛孔收斂緊緻，有效避免再次發生粉刺及毛孔粗大的困擾，透過先清潔再緊緻的方式，還給自己一張毛孔會呼吸的乾淨臉龐。"
					}
				},
				13: {
					1:{
						"no": 1,
						"brand": "L'OCCITANE歐舒丹",
						"product": "杏仁緊膚凝霜",
						"price": "NT.2280",
						"capacity" : "200ml",
						"image" : "13-6.jpg",
						"detail": "絲綢般乳霜質地，蘊含豐富的杏仁奶、杏仁油等活性成分，帶來柔適保濕效果，添加杏仁萃取及核桃籽，可維持肌膚彈性，使肌膚平滑緊緻，結合杏仁蛋白提升肌膚緊緻度，長效保濕，提升光澤感與彈潤度。清新宜人的杏仁香氣，使保養時光更加愉悅。"
					},
					2:{
						"no": 2,
						"brand": "Jurliaue茱莉蔻",
						"product": "恬蜜玫瑰身體乳",
						"price": "NT.1750",
						"capacity" : "300ml",
						"image" : "13-4.jpg",
						"detail": "蘊含豐富珍貴玫瑰精油、滋養的酪梨油、澳洲堅果油，有效滋潤粗糙肌膚，同時提升肌膚保水力，給予肌膚水潤彈的柔嫩光澤。"
					},
					3:{
						"no": 3,
						"brand": "AVEENO艾惟諾",
						"product": "燕麥高效舒緩保濕乳",
						"price": "NT.858",
						"capacity" : "345ml",
						"image" : "13-1.jpg",
						"detail": "含天然燕麥及乳木果萃取以及天然燕麥萃取，質地快速吸收不黏膩，24小時深層保濕，適合極乾燥及敏弱性肌膚，並能有效舒緩乾癢問題以及肌膚敏感問題。"
					},
					4:{
						"no": 4,
						"brand": "品木宣言",
						"product": "漫步在雲端腿部舒緩霜",
						"price": "NT.1150",
						"capacity" : "150ml",
						"image" : "13-9.jpg",
						"detail": "薄荷、絲柏、歐薄荷和雪松能舒緩疲累的雙腿，釋放肌肉緊張與力，讓您的雙腿恢復活力與生氣。取適量由腳踝、小腿、大腿，由下往上單一方向按摩。"
					}
				},
				14: {
					1:{
						"no": 5,
						"brand": "MOSCHINO",
						"product": "小粉紅‧清新女性淡香水",
						"price": "NT.1350/2500 ",
						"capacity" : " 30ml/50ml",
						"image" : "14-8.jpg",
						"detail": "清新女性淡香水從香味裡給你滿滿的粉紅色魅力！以玫瑰的香味為主調，幽默逗趣的瓶身設計小粉紅讓人不僅在嗅覺上視覺上也感受到MOSCHINO引爆的粉紅色氣息。"
					},
					2:{
						"no": 6,
						"brand": "CHANEL香奈兒",
						"product": "CHANCE 橙光輕舞淡香水",
						"price": "NT.2150/4350 ",
						"capacity" : "50ml/100ml",
						"image" : "14-3.jpg",
						"detail": "一款讓人想展翅高飛的香氛創作，象徵著滿載幸福的強烈生命力，這樣的活力並非稍縱即逝，恰巧相反，它散播著豐富充滿創造性的熱情奔放。緩緩綻放出葡萄柚與血橙混合的香味。柑橘的香味即刻賦予出此香氛清新、活力充沛的香調，而CHANCE系列不可或缺的茉莉、鳶尾花、白麝香與西洋杉也緩緩釋放出細緻花香。"
					},
					3:{
						"no": 7,
						"brand": "GUERLAIN嬌蘭",
						"product": "小黑裙搖滾皮衣玫瑰淡香精",
						"price": "NT.2250/37500 ",
						"capacity" : "30ml/50ml/90ml",
						"image" : "14-5.jpg",
						"detail": "經典倒心型瓶身全新演繹，深黑亮面外觀，猶如透亮的皮革。瓶子頸部以仿浮雕皮飾的鉚丁壓紋為亮點，完美呼應皮衣的質感，展現搖滾專屬的酷炫魅力。外觀標籤採用銀黑色調，強烈襯托黑色皮革與金屬綴飾細節。"
					},
					4:{
						"no": 8,
						"brand": "ANNA SUI",
						"product": "幸運精靈淡香水",
						"price": "NT.1650/2250/2800 ",
						"capacity" : "30ml/50ml/75ml",
						"image" : "14-1.jpg",
						"detail": "以清新的柑橘與紅柚帶領Anna Sui女孩尋找她的幸運，添加燦爛活潑的檸檬清香做為旅途中的輕跳旋律，美麗盛開的蒼蘭遇上蘭花，蹦出朵朵好運。細膩檀香和新鮮麝香的交叉音符，成就一首歡樂和Anna Sui女孩的優美歌曲，透過幸運精靈捕捉夢想的魅力。"
					}
				},
				15: {
					1:{
						"no": 9,
						"brand": "MA CHÉRIE 瑪宣妮",
						"product": "珍珠蜂蜜護髮精油",
						"price": "NT.290",
						"capacity" : "60ml",
						"image" : "15-3.jpg",
						"detail": "添加頂級成分蜂王乳萃取精華與珍珠蜂蜜精華，能徹底浸潤乾燥髮絲，滋養深入髮芯，讓秀髮重現柔亮滑順。完美隔離防護效果可隔絕吹整高溫及外在環境對秀髮的傷害，充分呵護絲絲秀髮。添加不沾煙香氛配方讓秀髮隨時隨地散發清爽花果甜香。"
					},
					2:{
						"no": 10,
						"brand": "Kiehl's契爾氏",
						"product": "氨基酸洗髮精",
						"price": "NT.840",
						"capacity" : "250ml",
						"image" : "15-1.jpg",
						"detail": "添加椰子油的氨基酸洗髮精，可溫和潔淨秀髮並其柔軟滑順，適合中偏乾頭髮與頭皮以及經常洗頭者適用。成分中的小麥澱粉及小麥蛋白素，再賦予髮絲柔順及亮澤時，更可添增髮質的豐盈感。氨基酸、椰子油可輕柔潔淨頭髮與頭皮，並提供乳狀的細緻泡沫。"
					},
					3:{
						"no": 11,
						"brand": "TSUBAKI思波綺",
						"product": "艷澤精油",
						"price": "NT.420",
						"capacity" : "50ml",
						"image" : "15-8.jpg",
						"detail": "嚴選萃煉來自日本長崎五島列島的高濃度山茶花精油，再加上高機能椿麴發酵精華，由浸透奈米修護精油技術帶來高度損傷修護效果，長效持續水潤的保濕效果，具備濕氣防禦機能，能修護潮濕氣候帶來的蓬鬆毛躁，具備熱損傷防禦效果可阻隔吹整造型帶來的熱損傷。"
					},
					4:{
						"no": 12,
						"brand": "L'OCCITANE歐舒丹",
						"product": "草本修護洗髮乳",
						"price": "NT.1280",
						"capacity" : "500ml",
						"image" : "15-2.jpg",
						"detail": "適合乾燥及染燙受損髮質，蘊含五種精華油修護配方，不含矽靈，能有效修護受損髮絲，活化髮根、滋潤養護秀髮，展現柔順亮澤秀髮。"
					}
				},
				16: {
					1:{
						"no": 13,
						"brand": "Clarisonic 科萊麗",
						"product": "音波緊顏淨膚儀",
						"price": "NT.12800",
						"capacity" : "1組",
						"image" : "16-3.jpg",
						"detail": "Clarisonic 科萊麗首創音波共震科技, 60 秒便能淨膚抗痘、清潔毛孔，音波緊顏淨膚儀更進一步將音波共震科技結合全新居家微整抗老概念,升級進化為音波拉提，以全球首創的音波共震科技,搭配能完美緊密貼合臉部至前胸的緊顏按摩頭,緊實拉提的雙頰。"
					},
					2:{
						"no": 14,
						"brand": "beautyblender®",
						"product": "美妝蛋",
						"price": "NT.690",
						"capacity" : "1入",
						"image" : "16-1.jpg",
						"detail": "以獨特的開放氣孔（Open Cell）物理原理研製而成，材質極度柔軟舒適而有彈性，泡水瀝乾後每個組織會膨脹，形成更緊密的表面，令妝容更加服貼。 且 Open Cell 結構能輕易擠壓出水份，粉底液只停留表面，不滲入內層，減少浪費化妝品，輕鬆營造出最薄透、最自然服貼的底妝。"
					},
					3:{
						"no": 15,
						"brand": "SK-II",
						"product": "磁力微振導入儀",
						"price": "NT.5789",
						"capacity" : "1組",
						"image" : "16-4.jpg",
						"detail": "首度運採用磁力微振技術(Magnetic MicroPulse Technology) ，每分鐘能持續溫和地產生高達7000rpm的磁性振動，能幫助SK-II R.N.A.超肌能系列產品中的保養成分更容易滲透肌膚，為肌膚注入活力。（與R.N.A.超肌能緊緻活膚霜搭配成SK-II R.N.A.超肌能活膚霜磁力微振組販售）"
					},
					4:{
						"no": 16,
						"brand": "ReFa S CARAT RAY",
						"product": "白金美容滾輪",
						"price": "NT.4800",
						"capacity" : "28g",
						"image" : "16-6.jpg",
						"detail": "雙引流滾輪，完美重現指尖輕揉的「點揉」動作，緊緻眼周、嘴角等較難照顧的細緻部位。搭配全新升級的手柄按壓點，除了滾輪滾動拉提外，更能實現理想的按摩手法。使鬆弛的眼角、嘴角肌膚重現緊緻動人光彩。"
					}
				}
			}

		}
	},
	props:{
		cosmoUrl: String,
		screenWidth: Number,
		allProcuctClass: {},
	},
	components:{
		Modal
	},
	watch:{
		allProductData(val){
			let self = this 
			self.allProductData = val 
			let ids = self.allProcuctClass
	  },
		modalShown(value){
		  let self = this 
		  self.modalShown = value
	  },
	},
	created (){
		// let scroll_e = VueScrollTo.scrollTo('.popular')
		// console.log("create");	
	},
	mounted(){
		let self = this
		console.log("mounted")
		self.scrollEvent()
	},
	 methods:{
		 toggleModalFlag: function(pdId){
			let self = this
			self.modalShown = !self.modalShown
			// console.log(self.modalShown)
		},
		 setImageUrl: function(productImage){
			let self = this 
			return self.cosmoUrl+'images/'+productImage
		},
		saveModalShowPd: function(pd){
			let self = this 
			self.modalPd = pd
			// console.log(pd)
			self.toggleModalFlag
		},
		searchPd: function(id){
			let self = this 
			let obj = self.manProduct
			
			// console.log(id)
			Object.keys(obj).forEach((key)=>{      
				if(obj[key].no == id)
				{
					// console.log(obj[key].no)
				}
			})   
		},
		scrollEvent(){
			let self = this
			let path = this.$route.path
			// console.log(path)
			if(path.includes('info') == true)
			{
				let scroll_e = VueScrollTo.scrollTo('.event-description')
			}else{
				let scroll_e = VueScrollTo.scrollTo('.popular')
			}
		}
	 }
}
</script>

<style lang="sass" scoped >
$main-color: #f21290
$btn-color: #8a7952
@mixin rwd($w)
	@media only screen and (max-width: $w) 
		@content
@mixin bgcentercover
	background-repeat: no-repeat
	background-position: 50% 50%
	background-size: cover
@mixin bgcenter
	background-repeat: no-repeat
	background-position: 50% 50%
	background-size: 100%

//vote class--------
.vote-pd-class-container
	width: 800px
	margin: 0 auto
	display: flex
	flex-direction: row
	justify-content: center
	flex-wrap: wrap
	.vote-pd-class-text
		flex-grow: 1
		width: calc(100% * (1/8))
		padding: 13px 0
		color: $main-color
		cursor: pointer
		text-align: center
	.vote-pd-class-eng 
		font-size: 13px
		font-weight: 300
		line-height: 1.69
		letter-spacing: 0.3px
	.vote-pd-class-chi
		font-size: 18px
		font-weight: bold
		line-height: 1.22
		letter-spacing: normal
//----------
.popular 
	background-image: url(../assets/images/d-bg.jpg)
	background-position: 50% 0
	background-size: cover
	background-repeat: no-repeat
	background-attachment: fixed
	padding-bottom: 100px
.man-top 
	width: 100%
	height: 600px
	position: relative
	// overflow: hidden
	padding-top: 21px
	// background-color: #000
	z-index: 1
	padding-top: 64px
	img 
		margin: 0 auto
		margin-bottom: (43-18px)
	&:after
		content: ''
		position: absolute
		z-index: -1
		top: 0
		left: calc(50% - 1280px)
		height: 684px
		width: 2560px
		background-image: url(../assets/images/d-page-kv.png)
		background-position: 50% 0
		background-size: cover
		background-repeat: no-repeat
	// &:before
	// 	content: ''
	// 	position: absolute
	// 	left: 0
	// 	bottom: -600px
	// 	width: 100%
	// 	height: 600px
	// 	background: linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -moz-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	// 	background: -o-linear-gradient(180deg, rgba(0, 0, 0, 1)0%, rgba(255, 255, 255, 0)33%) 
	.bw-logo
		height: 54px
		position: absolute
		top: 21px
		left: calc(50% - 600px)
		img 
			height: 100%
.man-pd-container
	width: 100%
	// height: 800px
	margin-top: -200px
	z-index: 5
	position: relative
	&:after 
		content: ''
		position: absolute
		top: 0
		width: 1238px
		left: calc(50% - 619px)
		height: 2px
		opacity: 0.6
		background-image: linear-gradient(to right, #03001e 1%, #7303c0 10%, #ec38bc 49%, #7303c0 87%, #03001e)
	
.category-conatiner
	display: flex
	flex-direction: row
	margin: 0 auto
	justify-content: space-between
	align-items: flex-end
	width: 1286px
	position: relative
	padding-top: 165px
.category-title
	width: 189px
	height: 280px
	background-image: url(../assets/images/category-bg-popular.png)
	background-position: 50% 50%
	background-repeat: no-repeat
	background-size: cover
	display: flex
	justify-content: center
	align-items: center
	flex-direction: column
	>.category-name
		font-size: 33px
		font-weight: 500
		line-height: 1.21
		letter-spacing: 0.8px
		font-weight: bold
		text-align: center
		color: #fff
		position: relative
		display: inline-block
		text-align: center
		&-eng 
			color: #fff
			font-size: 22px
			font-weight: 300
			line-height: 1.82
			letter-spacing: 0.6px
	
.pd-item
	width: 270px
	height: 270px
	position: relative
	+bgcentercover
	cursor: pointer
	background-color: #fff
	position: relative
	color: #fff 
	text-align: center
	&:hover 
		.pd-cover 
			opacity: 1
			visibility: visible
	.pd-brand,
	p,
	.pd-detail
		font-size: 18px
		font-weight: 500
		line-height: 1.55
		text-align: center
		color: #ffffff
		line-height: 1.56
	.pd-detail
		background-color: $btn-color
		width: 120px
		height: 35px
		line-height: 35px
		margin: 0 auto
		margin-top: 10%
	.pd-cover 
		width: 100%
		height: 100%
		background-image: url('../assets/images/pd-cover-popular.png')
		+bgcentercover
		position: absolute
		top: 0
		left: 0
		opacity: 0
		visibility: hidden
		transition: opacity .35s, visibility .35s, height .35s
		z-index: 3
		display: flex
		flex-direction: column
		justify-content: center
		align-items: center
		padding: 0 4%


%pd-after-common
	content: ''
	position: absolute
	background-position: 50% 50%
	width: 	42px
	height: (38px+17px+19px)
	background-size: 100%
	background-repeat: no-repeat
	top: -(74px+21px)
	left: calc(50% - 35px)		
.pd-top1
	&:after
		background-image: url('../assets/images/popular-item-title-1.png')
		@extend %pd-after-common
.pd-top2
	&:after
		background-image: url('../assets/images/popular-item-title-2.png')
		@extend %pd-after-common
.pd-top3
	&:after
		background-image: url('../assets/images/popular-item-title-3.png')
		@extend %pd-after-common
.pd-star
	&:after
		background-image: url('../assets/images/popular-item-title-4.png')
		content: ''
		position: absolute
		background-position: 50% 50%
		width: 66px
		height: 56px
		background-size: 100%
		background-repeat: no-repeat
		top: -(56px+21px)
		left: calc(50% - 33px)	

.event-description
	width: 1220px
	height: 1430px 
	background-image: url(../assets/images/d-event-border.png)
	background-position: 0 0
	background-repeat: no-repeat
	background-size: contain
	margin: 60px auto 0 auto
	padding: 74px 107px 91px 107px 
	>.event-list
		>li 
			font-size: 24px
			font-weight: 500
			line-height: 1.6
			letter-spacing: 0.6px
			text-align: left
			color: #d9c476
			position: relative
			margin-bottom: 38px
			&:after 
				content: "\f0de"
				font-family: FontAwesome
				color: #d9c476
				font-size: 14px
				position: absolute
				left: -20px
				top: 10px
				transform: rotate(90deg)
			p 	
				padding-top: 12px

		p,
		.care-list li
			color: #ffffff
			font-size: 16px
			line-height: 1.56
			letter-spacing: 0.4px
			text-align: justify
		.care-list 
			list-style-type: disc
			padding-left: 24px
			padding-top: 12px

		.gift 
			padding-top: 26px
+rwd(1200px)
	.vote-pd-class-container
		width: 100%
		.vote-pd-class-text
			// width: calc(100% * (1/6))
			width: auto
			margin: 0 18px
		.vote-pd-class-eng 
			font-size: 18.6px
			font-weight: 300
			line-height: 1.67
			letter-spacing: 0.5px
		.vote-pd-class-chi
			font-size: 29.5px
			font-weight: bold
			line-height: 1.05
	.man-top 
		width: 100%		
		background: none
		padding: 0
		padding-top: 183px
		height: auto
		padding-bottom: 14px
		&:after 
			height: 775px
			width: 100%
			left: 0
			top: 0
			background-image: url(../assets/images/m-page-kv-n.png)
			background-position: 0% 0	
			background-size: 100%
			background-color: transparent
			background-repeat: no-repeat
		img 

		.bw-logo 
			height: auto 
			left: 35px
		.man-title 
			padding-top: 144px
			margin-bottom: 20px	
	.man-pd-container
		margin-top: 0
		height: auto
		padding-bottom: 130px
	.category-conatiner
		width: 90%
		margin: 0 auto	
		flex-wrap: wrap
		padding-top: 34px
		// justify-content: space-evenly
		&:after 
			width: 100%

	.category-title
		width: 650px
		margin: 0 auto	
		height: 232px	
		background-image: url(../assets/images/category-bg-m-popular.png)
		>.category-name
			font-size: 53.1px
			line-height: 1.22
			letter-spacing: 1.3px
			font-weight: 500
			&-eng 
				font-size: 38.4px
				font-weight: 300
				line-height: 1.69
				letter-spacing: 1px
	
	
	$pd-item: 320px
	.pd-item
		width: $pd-item
		height: $pd-item
		margin-top: (115px+16px+23px)
		.pd-cover 
			opacity: 1
			visibility: visible
			background-image: url(../assets/images/popular-more.png)
			background-position: 97% 97%
			background-size: 15%
			h4,p,div
				display: none
		&:after 
			width: 65px
			height: 115px
			left: calc(50% - 32.5px)
			top: -(115px+16px)
	.pd-star 
		&:after 
			width: 86px
			height: 76px
			left: calc(50% - 43px)
			top: -(76px+16px)
	.event-description
		background: none
		padding: 0 5%
		width: 100%
		height: auto
		padding-bottom: 10%
		>.event-list 
			>li 
				font-size: 34px
				letter-spacing: 0.9px
				font-weight: 300
				&:after 
					font-size: 18px
					top: 14px
				p,
				.care-list li  
					font-size: 28px
					line-height: 1.43
					padding-top: 8px
					font-weight: 300
				.care-list li 
					padding-top: 0
</style>



// WEBPACK FOOTER //
// Popular.vue?7eda24b0